import React, { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "./ErrorDrgReport.css";

import ReportTable from "../ReportTable";
import ErrorDrgReportFilter from "./ErrorDrgReportFilter";
import { useReport } from "../hooks/useReport";
import { batchUpdateAppliedFilters } from "../redux/ReportsSlice";

import totalOutstanding from "../../../../common/assets/images/notification-box.png";
import highPriority from "../../../../common/assets/images/highPriority.png";
import calendar from "../../../../common/assets/images/calendar.png";
import hourglass from "../../../../common/assets/images/hourglass.png";
// import { exportReportData } from "../redux/ReportsSlice";
import { getReportConfig } from "../optionsConfig";
import { useSelector } from "react-redux";

const REPORT_PATH = "/error-drg-report";
const reportAPIConfig = getReportConfig(REPORT_PATH);


const ErrorDrgReport = () => {
  const dispatch = useDispatch();
const appliedFilters = useSelector(
  (s) => s.reports.appliedFilters[REPORT_PATH] || {});

  const {
    episodes,
    reportData,
    totalPages,
    pageNumber,
    setPageNumber,
    reportLoading,
    reportError,
    exportLoading,
    // handleExport,
    handleReset,
    resetSignal,
    setSortPayload,
  } = useReport(REPORT_PATH);

  const [searchText, setSearchText] = useState("");
const [sortPayload, setSortPayloadState] = useState({});
  // ── Column-header filter apply (same pattern as DRGReport) ──
  const handleColumnFilterApply = useCallback(
    (filters) => {
      dispatch(
        batchUpdateAppliedFilters({
          reportPath: REPORT_PATH,
          filters,
        }),
      );
      setPageNumber(1);
    },
    [dispatch, setPageNumber],
  );

  // ── Single-field search (no field toggle needed for Error DRG) ──
  const handleSearchChange = useCallback(
    (value) => {
      setSearchText(value || "");
      dispatch(
        batchUpdateAppliedFilters({
          reportPath: REPORT_PATH,
          filters: { search: value || "" },
        }),
      );
      setPageNumber(1);
    },
    [dispatch, setPageNumber],
  );
const buildExportPayload = useCallback((filters, search, sort) => {
  const payload = {};

  if (search) payload.search_term = [search];
  if (sort?.sort_by) payload.sort_by = sort.sort_by;
  if (sort?.sort_order) payload.sort_order = sort.sort_order;

  ["episode_id", "episode_type", "speciality", "status", "drg_code"].forEach(
    (k) => {
      if (Array.isArray(filters[k]) && filters[k].length > 0) {
        payload[k] = filters[k];
      }
    }
  );

  return payload;
}, []);

  // ── Widget cards ──
  // const cards = reportData?.cards_data || reportData?.data?.cards_data;

  // const hasCards = cards && Object.values(cards).some((v) => v != null);
  // const widgets = [
  //   {
  //     label: "801 DRGs",
  //     count: cards?.count_801_drg,
  //     bgColor: "#EFF6FF",
  //     icon: totalOutstanding,
  //   },
  //   {
  //     label: "960Z DRGs",
  //     count: cards?.count_960z_drg,
  //     bgColor: "#FEF2F2",
  //     icon: highPriority,
  //   },
  //   {
  //     label: "961Z DRGs",
  //     count: cards?.count_961z_drg,
  //     bgColor: "#FEFCE8",
  //     icon: calendar,
  //   },
  //   {
  //     label: "963 DRGs",
  //     count: cards?.count_963z_drg,
  //     bgColor: "#ECFDF5",
  //     icon: hourglass,
  //   },
  // ];

  return (
    <div className="outstanding-filters-section mt-3 px-2">
      <h4 className="pb-2" style={{ flexShrink: 0 }}>
        Error DRG Report
      </h4>

      {/* ── Widget cards ── */}
      {/* {hasCards && (
        <div className="d-flex gap-2 mb-3 flex-wrap" style={{ flexShrink: 0 }}>
          {widgets.map((w) => (
            <div key={w.label} className="outstanding-widget col" style={{ background: w.bgColor }}>
              <div>
                <p className="mb-1">{w.label}</p>
                {reportLoading ? (
                  <Skeleton width={60} />
                ) : (
                  <p className="mb-0 fw-bold">{w.count ?? '-'}</p>
                )}
              </div>

              <div>
                <img src={w.icon} alt={w.label} />
              </div>
            </div>
          ))}
        </div>
      )} */}
      <ReportTable
        key="error-drg"
        episodes={episodes}
        isReportLoading={reportLoading}
        isReportError={reportError}
        reportPageNumber={pageNumber}
        setReportPageNumber={setPageNumber}
        // handleReportExport={handleExport}
        reportExcelLoading={exportLoading}
        handleSearchChange={handleSearchChange}
        totalPages={totalPages}
        searchText={searchText}
        setSearchText={setSearchText}
        onSortChange={setSortPayload}
        onReset={handleReset}
        resetSignal={resetSignal}
        onColumnFilterApply={handleColumnFilterApply}
        reportData={reportData}
      />

      <ErrorDrgReportFilter onApply={() => setPageNumber(1)} />
    </div>
  );
};

export default ErrorDrgReport;
